// @flow
import types from "./types";

const setOriginInputAddress = (address: string) => ({
    type: types.ORIGIN_INPUT_SET,
    payload: address

});

export default {
    setOriginInputAddress,
};


// WEBPACK FOOTER //
// ./src/Store/Ducks/OriginAutocomplete/actions.js